import React from 'react';
import { ResizableBox } from 'react-resizable';
import renderIf from 'render-if';

/**
 * @param {{ timelineConfig: object, width: string, height: string, extraHeight: boolean, showMilestoneBars: string, newWidths: object, updateHeaderWidths: object, persistHeaderWidths: object, headerWidths: Array }} props
 */

export default /**
 * @typedef TimelineSidebarHeaderProps
 * @prop {*=} timelineConfig
 * @prop {*=} width
 * @prop {*=} height
 * @prop {*=} extraHeight
 * @prop {*=} showMilestoneBars
 * @prop {*=} updateHeaderWidths
 * @prop {*=} persistHeaderWidths
 * @prop {*=} headerWidths
 */
/**
 * @type {React.FC<TimelineSidebarHeaderProps>}
 */

function TimelineSidebarHeader({
  timelineConfig,
  width,
  height,
  extraHeight,
  showMilestoneBars,
  updateHeaderWidths,
  persistHeaderWidths,
  headerWidths,
}) {
  const handleResize = (index, newWidth) => {
    const newWidths = [...headerWidths];
    newWidths[index] = newWidth;
    updateHeaderWidths(newWidths);
  };

  const handleResizePersist = (index, newWidth) => {
    const newWidths = [...headerWidths];
    newWidths[index] = newWidth;
    persistHeaderWidths(newWidths);
  };

  const headerTitles = () => {
    return timelineConfig.headingTitles.map((heading, index) => (
      <div key={`${index}-${heading}`} className='row-header-td'>
        {renderIf(window.featureFlags.a_16745_custom_timeline_resizeable)(
          <ResizableBox
            axis='x'
            handle={
              <div
                className='react-resizable-handle'
                draggable
                onDragStart={e => e.preventDefault()}
                style={{ left: headerWidths.length === index + 1 ? 3 : 5 }}
              />
            }
            onResize={(e, data) => handleResize(index, data.size.width)}
            resizeHandles={['e']}
            width={headerWidths[index]}
            onResizeStop={(e, data) =>
              handleResizePersist(index, data.size.width)
            }
          >
            <div className='row-header-inner'>{heading}</div>
          </ResizableBox>
        )}
        {renderIf(!window.featureFlags.a_16745_custom_timeline_resizeable)(
          <div
            className='react-resizable'
            style={{
              left: headerWidths.length === index + 1 ? 3 : 5,
              width: headerWidths[index],
            }}
          >
            <div className='row-header-inner'>{heading}</div>
          </div>
        )}
      </div>
    ));
  };

  const rowHeaders = () => {
    if (timelineConfig.showHeadings) {
      return (
        <div className='row-header' style={{ width }}>
          {headerTitles()}
        </div>
      );
    }
  };

  const milestones = timelineConfig.milestones;
  const totalWidth =
    headerWidths.reduce((a, b) => a + b, 0) + headerWidths.length;

  const style = {
    width: totalWidth,
    height:
      milestones && milestones.length > 0 && showMilestoneBars
        ? `calc(var(--custom-timeline-milestone-swimlane-height) + ${
            height + extraHeight
          }px)`
        : `${height}px`,
    left: 0,
  };

  return (
    <div className='timeline-pivot-sticky-corner' style={style}>
      {rowHeaders()}
    </div>
  );
}
